import React from 'react'
import TermListEntry from './TermListEntry';
import { v4 as uuidv4 } from 'uuid'; 
export default function TermList({oym,list,dropBreadcrumb,authenticated,noTerm,noOffice}) {
    // console.log(list);
    let objectList=list.map(term => oym.objectRef(term));
    // console.log(objectList);
    // console.log(compareTerm(objectList[0],objectList[1]));
    objectList.sort(compareTerm);
    // let elementList = objectList.map(term => {
    //     return <TermListEntry key={uuidv4()} oym={oym} term={term} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} />
    // });
    return (
        objectList.map(term => {
            return <TermListEntry key={uuidv4()} oym={oym} term={term} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} noTerm={noTerm} noOffice={noOffice} />
        })
            );
    function compareTerm(term1,term2){
        let friend1=oym.objectRef(term1.friend);
        let friend2=oym.objectRef(term2.friend);
        return oym.compareFriend(friend1,friend2);
    }
}
